import React, { useContext, useCallback, memo } from "react";
import Drawer from "@material-ui/core/Drawer";

// context
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";
import { DispatchContext as HomeDispatchContext } from "bodycodi/cmap/app/components/cmap2010/home";

// components
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";
import CommentUpdateDrawer from "./CommentUpdateDrawer";

// utils
import { api } from "bodycodi/cmap/app/js/api";

// assets
import icon_update from "bodycodi/cmap/app/img/icon_update.png";
import icon_delete_red from "bodycodi/cmap/app/img/icon_delete_red.png";

// types
import { CommentDrawerProps } from "./types";

const CommentDrawer = ({ selectedComment, refresh }: CommentDrawerProps) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = useCallback(() => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "COMMENT_CONFIRM_POP",
      open: { commentConfirmPop: false },
    });
  }, []);

  return (
    <Drawer
      anchor="bottom"
      open={state.commentConfirmPop}
      onClose={handleClose}
      className="picker-pop auto"
    >
      <PickerHeader title="" onClose={handleClose} />
      <DrawerContent
        selectedComment={selectedComment}
        refresh={refresh}
        handleClose={handleClose}
      />
    </Drawer>
  );
};

const DrawerContent = ({ selectedComment, refresh, handleClose }: any) => {
  const { dispatch } = useContext(DispatchContext);
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);

  const openUpdateDrawer = () => {
    dispatch({ type: "POP_UP_OPEN", id: "COMMENT_UPD_POP", open: { commentUpdPop: true } });
  };

  const deleteComment = () => {
    api
      .post("/cmap4020/execCmntUseYnUpd ", {
        cmntId: selectedComment.cmntId,
      })
      .then(() => {
        refresh();
        handleClose();
        homeDispatch({ type: "UPDATE_COMUNITY" });
      });
  };

  const deleteCommontAlert = () => {
    dispatch({
      type: "ALERT_SETTING",
      data: {
        alert: true,
        cancleYn: "D",
        redYn: true,
        header: "댓글 삭제",
        body: "댓글을 삭제하시겠어요?\n 삭제하시면 복구하실 수 없습니다.",
        cancelAlert: () => ({}),
        closeAlert: deleteComment,
      },
    });
  };

  return (
    <>
      <div className="comment-confirm-pop">
        <div className="btn" onClick={openUpdateDrawer}>
          <img src={icon_update} />
          수정
        </div>
        <div className="btn_red" onClick={deleteCommontAlert}>
          <img src={icon_delete_red} />
          삭제
        </div>
      </div>
      <CommentUpdateDrawer
        selectedComment={selectedComment}
        refresh={refresh}
        closeConfirm={handleClose}
      />
    </>
  );
};

export default CommentDrawer;
